import SDDarkBackground from '@/assets/ThemeImages/SDDark/login-bg.jpg'
import SDDarkLoginLogo from '@/assets/ThemeImages/SDDark/login-logo.svg'
import SDDarkTransLogo from '@/assets/ThemeImages/SDDark/login-trans-logo.png'
import SDLightBackground from '@/assets/ThemeImages/SDLight/login-bg.jpg'
import SDLightLoginLogo from '@/assets/ThemeImages/SDLight/login-logo.svg'
import SDLightTransLogo from '@/assets/ThemeImages/SDLight/login-trans-logo.png'
import type { ThemeConfig } from '@gravitate-js/excalibrr'
import Color from 'color'

export const themeConfigs: ThemeConfig[] = [
  {
    display: 'Light',
    key: 'sd_light',
    isDark: false,
    default: true,
    colors: {
      info: '#002B58',
      nav1: '#19304B',
      nav2: Color('#19304B').lighten(0.8).hex(),
    },
    nav: {
      bgColor: '#19304B',
      routeTextColor: 'rgba(255, 255, 255, 0.85)',
      routeActiveTextColor: '#FFFFFF',
      routeActiveBgColor: 'rgba(255, 255, 255, 0.12)',
      routeActiveFill: '#2C4E78',
      routeHoverTextColor: '#FFFFFF',
      routeHoverBgColor: 'rgba(255, 255, 255, 0.08)',
    },
    loginLogoImage: SDLightLoginLogo,
    loginBackgroundImage: SDLightBackground,
    loginTransLogoImage: SDLightTransLogo,
  },
  {
    display: 'Dark',
    key: 'sd_dark',
    isDark: true,
    colors: {
      info: '#59cfff',
      nav1: '#19304B',
      nav2: Color('#19304B').lighten(0.8).hex(),
    },
    nav: {
      bgColor: '#19304B',
      routeTextColor: 'rgba(255, 255, 255, 0.95)',
      routeActiveTextColor: '#FFFFFF',
      routeActiveBgColor: 'rgba(255, 255, 255, 0.12)',
      routeHoverTextColor: '#FFFFFF',
      routeHoverBgColor: 'rgba(255, 255, 255, 0.08)',
    },
    loginLogoImage: SDDarkLoginLogo,
    loginBackgroundImage: SDDarkBackground,
    loginTransLogoImage: SDDarkTransLogo,
  },
]
